import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import HubSpotForm from './HubSpotForm';

const ContactForm = ({ params }) => {
  const { form } = useStaticQuery(graphql`
    {
      form: hubSpotForm(id: { eq: "fe472c1c-2c3a-4938-951e-2f708a02b3c9" }) {
        id
        name
        metaData {
          name
          value
        }
        formFieldGroups {
          fields {
            name
            label
            fieldType
            required
            options {
              label
              value
            }
            defaultValue
            type
            hidden
            placeholder
          }
        }
      }
    }
  `);
  
  return <HubSpotForm form={form} params={params} />;
};

export default ContactForm;
